<template>
  <div class="initiative invoice">
		<div class="box">
			<el-row class="content">
				<el-col :span="12" class="txt">
					<h4 class="title">商家主动开票</h4>
					<p class="desc">商户通过小程序或网页版后台，主动发起开票。</p>
					<p class="desc tip">适用于餐饮、酒店、药店、停车场、水果店、花店等门店类</p>
				</el-col>
				<el-col :span="12" class="invoicing-box">
					<div class="invoicing-img"><img width="100%" src="../assets/product/initiative.png" alt="" srcset=""></div>
				</el-col>
			</el-row>
		</div>

		<div class="box instructions">
			<div class="content">
				<h3 class="tit">使用方法</h3>
				<div class="img-box applets-box">
					<P class="sub-title">小程序开票流程</P>
					<el-row class="img-list" v-if="!isMobile">
						<el-col :span="6" v-for="item in instructionsList1" :key="item.id">
							<div class="img">
								<img :src="item.url" alt="">
							</div>
							<p class="desc"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
						</el-col>
					</el-row>
					<el-carousel trigger="click" ref="carousel" v-else>
						<el-carousel-item v-for="item in instructionsList1" :key="item.id">
							<img height="90%" :src="item.url" alt="">
							<p class="img-info"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
						</el-carousel-item>
					</el-carousel>
				</div>

				<div class="img-box">
					<P class="sub-title">PC端开票流程</P>
					<el-row class="img-list pc-flex" v-if="!isMobile">
						<el-col :span="12" v-for="item in instructionsList2" :key="item.id">
							<div class="img">
							<img :src="item.url" alt="">
							</div>
							<p class="desc"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
						</el-col>
					</el-row>
					<el-carousel class="instructions-list2" v-else trigger="click" ref="carousel">
						<el-carousel-item v-for="item in instructionsList2" :key="item.id">
              <div class="img">
                <img width="100%" height="100" :src="item.url" alt="">
              </div>
							<p class="img-info"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>

		<div class="box process">
			<div class="content">
				<h3 class="title">接入流程</h3>
				<ul class="process-list">
					<li class="lis">
						<div class="img-box">
							<img class="img1" src="../assets/svg/support-hotline.svg" alt="">
						</div>
						<div class="desc">
							<p>咨询电话：</p>
							<p>张经理 16625500010</p>
						</div>
					</li>
					<li class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img2" src="../assets/svg/platform-regist.svg" alt="">
						</div>
						<div class="desc">
							<p>商家在pc平台注册</p>
						</div>
					</li>
					<li class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img3" src="../assets/svg/examination-passed.svg" alt="">
						</div>
						<div class="desc">
							<p>审核通过</p>
						</div>
					</li>
					<li class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img4" src="../assets/svg/invoicing.svg" alt="">
						</div>
						<div class="desc">
							<p>开具发票</p>
						</div>
					</li>
				</ul>
				<el-button plain class="btn btn-xm" @click="handleToMerchant">马上试用</el-button>
			</div>
		</div>

  </div>
</template>

<script>
const img1 = require('@/assets/product/initiative1.png')
const img2 = require('@/assets/product/initiative2.png')
const img3 = require('@/assets/product/initiative3.png')
const img4 = require('@/assets/product/initiative4.png')

const img5 = require('@/assets/product/pc1.png')
const img6 = require('@/assets/product/pc2.png')
const img7 = require('@/assets/product/pc3.png')
const img8 = require('@/assets/product/pc4.png')
export default {
	name: 'Initiative',
	data() {
		return {
			instructionsList1: [
				{
					id: '1',
					num: '01',
					title: '在发票列表点击开票',
					url: img1
				}, {
					id: '2',
					num: '02',
					title: '填写开票信息',
					url: img2
				},
				{
					id: '3',
					num: '03',
					title: '提交开票',
					url: img3
				}, {
					id: '4',
					num: '04',
					title: '审核通过，开票成功',
					url: img4
				}
			],
			instructionsList2: [
				{
					id: '1',
					num: '01',
					title: '在发票列表点击开票',
					url: img5
				}, {
					id: '2',
					num: '02',
					title: '填写开票信息',
					url: img6
				},
				{
					id: '3',
					num: '03',
					title: '提交开票',
					url: img7
				}, {
					id: '4',
					num: '04',
					title: '开票成功',
					url: img8
				}
			],
			isMobile: false
		}
	},
	mounted() {
		this.isMobile = this.UA().mobile
	},
	methods: {
		handleToMerchant() {
			window.open('https://shanghu.jupiaotong.cn/')
		}
	}
}
</script>

<style lang="less" scoped>
.invoice {
	.invoicing-img {
		display: flex;
		align-items: end;
	}
	.instructions {
		.content {
			.img-box {
				background: #fff;
				margin-bottom: .66rem;
				.img {
					img {
						width: 100%;
					}
				}
			}
			.applets-box {
				padding: .3rem 0 1rem;
				.img-list {
					// height: 6.4rem;
					// padding: .8rem 0 1rem;
				}
				.img {
					padding: .1rem .2rem;
					height: 100%;
					img {
						width: 100%;
						height: 100%;
					}
				}
				/deep/ .el-col {
					display: flex;
					flex-direction: column;
				}
			}
			.sub-title {
				padding: .6rem .4rem .3rem;
				text-align: left;
				color: #2F2E40;
				font-size: .2rem;
			}
			.img-list {
				display: flex;
				justify-content: center;
				// align-items: center;
				.desc {
					margin-top: .2rem;
				}
				.num {
					font-size: .3rem;
					font-family:Arial Narrow;
					font-weight: 400;
					font-style: italic;
					color:rgba(183,28,34,1);
					margin-right: .1rem;
				}
			}
			.pc-flex {
				flex-flow: wrap;
				padding-bottom: 1rem;
				.num {
					color: #E38D48;
				}
			}
		}
	}
}
@media (max-width: 768px) {
	.invoice {
		.instructions {
			.content {
				.sub-title {
					font-size: .26rem;
        }
        .applets-box {
          padding: 0.3rem 0;
        }
				.instructions-list2 {
					.el-carousel__container {
						.img {
              height: 80%;
							img {
								height: 90%;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Initiative.vue